import { useEffect, useRef, useState } from 'preact/hooks';
import { WidgetRenderer } from './WidgetRenderer.jsx';
import { resolveResponsiveProfile } from '../adapters/responsiveAdapter.js';

export function ScaleCanvas({ tree, editMode = false, selectedId, onSelect, onPreview, onCommit, zoom = 1, className = '' }) {
  const shellRef = useRef(null);
  const designWidth = tree.props.referenceWidth;
  const designHeight = tree.props.referenceHeight;
  const [availableWidth, setAvailableWidth] = useState(designWidth);
  const [viewportWidth, setViewportWidth] = useState(() => window.innerWidth);

  useEffect(() => {
    const element = shellRef.current;
    if (!element) return undefined;
    const observer = new ResizeObserver(([entry]) => setAvailableWidth(entry.contentRect.width));
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const resize = () => setViewportWidth(window.innerWidth);
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);

  const naturalScale = Math.min(1, availableWidth / designWidth);
  const scale = editMode ? naturalScale * zoom : naturalScale;
  const height = designHeight * scale;
  const activeProfile = resolveResponsiveProfile(tree, viewportWidth);

  return (
    <div ref={shellRef} class={`canvas-shell ${className}`} data-responsive-profile={activeProfile} data-testid={editMode ? 'editor-canvas-shell' : 'public-canvas-shell'} style={{ height: `${height}px` }}>
      <div class="scaled-canvas" style={{ width: `${designWidth}px`, height: `${designHeight}px`, transform: `scale(${scale})` }}>
        <WidgetRenderer
          widget={tree}
          root
          editMode={editMode}
          selectedId={selectedId}
          canvasScale={scale}
          rootWidth={designWidth}
          rootHeight={designHeight}
          parentWidth={designWidth}
          parentHeight={designHeight}
          activeProfile={activeProfile}
          onSelect={onSelect}
          onPreview={onPreview}
          onCommit={onCommit}
        />
      </div>
    </div>
  );
}
